"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSharedERC = processSharedERC;
const tslib_1 = require("tslib");
const converters_1 = require("../drc/converters");
const reviews_1 = require("../reviews");
const converters_2 = require("./converters");
function convertProblemToReviewCheck(documentUid, inProgress, reviewType, problems, _validator, reviewsByUid, toItemFromProblem) {
    const review = reviews_1.reviewData[reviewType];
    const reviewUid = `rev_${review.type}`;
    const reviewChecks = problems.map((problem, index) => {
        const { status = reviews_1.ReviewStatus.ERROR, designatorUidMap, ...item } = toItemFromProblem(problem);
        const ids = problem?.affectedItems?.map((affectedItem) => affectedItem.uid) ?? (item.name ? [item.name] : []);
        const reviewCheckUid = (0, reviews_1.createDRCCheckId)(reviewType, ids);
        const reviewCheck = reviewsByUid[reviewUid]?.checks[reviewCheckUid];
        // For the link, prefer using UIDs from designatorUidMap (which can be matched by useFitToDesignator)
        // Fall back to item.name for display purposes
        const linkTargets = Object.values(designatorUidMap ?? {});
        const linkTarget = linkTargets.length > 0 ? linkTargets.join(", ") : item.name ?? "";
        const reviewCheckItem = {
            uid: reviewCheckUid,
            reviewUid,
            documentUid,
            assignedStatus: reviewCheck?.assignedStatus,
            name: item.name ?? "",
            index: index,
            status,
            link: (0, converters_1.generateComponentLink)(linkTarget),
            description: review.description,
            data: { problem, ...item },
            designatorUidMap,
        };
        return [reviewCheckUid, reviewCheckItem];
    });
    const checks = Object.fromEntries(reviewChecks);
    const status = inProgress
        ? reviews_1.ReviewStatus.RUNNING
        : problems.length
            ? (0, reviews_1.aggregateReviewStatus)(Object.values(checks).map((check) => check.status))
            : reviews_1.ReviewStatus.SUCCESS;
    return {
        ...review,
        uid: reviewUid,
        documentUid,
        status,
        assignedStatus: reviewsByUid[reviewUid]?.assignedStatus,
        columns: Object.fromEntries(Object.keys(review.columns).map((key) => [key, { ...review.columns[key], uid: key }])),
        checks,
    };
}
function processSharedERC(input) {
    const { documentUid, detectedProblems, checksInProgress, validators, schematicElements, reviewsByUid, showHiddenChecks, } = input;
    const ercReviews = validators
        .map((validator) => {
        const problems = Object.values(detectedProblems).filter((problem) => problem.problemTypeKey === validator.problemTypeKey);
        // Skip validators that are hidden by default and have no problems (unless showHiddenChecks is enabled)
        if (!showHiddenChecks && validator.defaultHidden && problems.length === 0) {
            return undefined;
        }
        const isCheckInProgress = checksInProgress[validator.problemTypeKey] ?? false;
        // Use validator.reviewType directly - no string concatenation magic
        switch (validator.reviewType) {
            case reviews_1.ReviewType.DesignRuleCheckMissingFootprints:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckMissingFootprints, problems, validator, reviewsByUid, (0, converters_2.convertMissingFootprints)(schematicElements));
            case reviews_1.ReviewType.DesignRuleCheckManufacturePartNumber: {
                const sortedProblems = (0, converters_2.sortMpnProblems)(problems, schematicElements);
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, reviews_1.ReviewType.DesignRuleCheckManufacturePartNumber, sortedProblems, validator, reviewsByUid, (0, converters_2.convertManufacturePartNumber)(schematicElements));
            }
            // All other ERC validators use the generic converter
            case reviews_1.ReviewType.DesignRuleCheckErcDriverConflict:
            case reviews_1.ReviewType.DesignRuleCheckErcDuplicateReference:
            case reviews_1.ReviewType.DesignRuleCheckErcFloatingPin:
            case reviews_1.ReviewType.DesignRuleCheckErcNoConnect:
            case reviews_1.ReviewType.DesignRuleCheckErcPinToPin:
            case reviews_1.ReviewType.DesignRuleCheckErcShortedComponents:
            case reviews_1.ReviewType.DesignRuleCheckErcPowerPin:
            case reviews_1.ReviewType.DesignRuleCheckErcSimilarLabels:
            case reviews_1.ReviewType.DesignRuleCheckErcSinglePinNet:
            case reviews_1.ReviewType.DesignRuleCheckErcUndrivenNet:
            case reviews_1.ReviewType.DesignRuleCheckErcWireDangling:
            case reviews_1.ReviewType.DesignRuleCheckErcUnconnectedWireEndpoint:
            case reviews_1.ReviewType.DesignRuleCheckErcUnannotated:
            case reviews_1.ReviewType.DesignRuleCheckErcSimilarPower:
            case reviews_1.ReviewType.DesignRuleCheckErcSimilarLabelAndPower:
            case reviews_1.ReviewType.DesignRuleCheckErcDifferentUnitFootprint:
            case reviews_1.ReviewType.DesignRuleCheckErcDifferentUnitNet:
            case reviews_1.ReviewType.DesignRuleCheckErcDifferentUnitValue:
                return convertProblemToReviewCheck(documentUid, isCheckInProgress, validator.reviewType, problems, validator, reviewsByUid, (0, converters_2.convertGenericErcProblem)(schematicElements));
        }
    })
        .filter(Boolean);
    const isAnyCheckInProgress = Object.values(checksInProgress).some(Boolean);
    return {
        name: reviews_1.ReviewCategoryType.DesignRuleChecks,
        status: isAnyCheckInProgress
            ? reviews_1.ReviewStatus.RUNNING
            : !ercReviews.length
                ? reviews_1.ReviewStatus.OPEN
                : (0, reviews_1.aggregateReviewStatus)(ercReviews.map((review) => review.assignedStatus ?? review.status)),
        reviews: ercReviews,
    };
}
tslib_1.__exportStar(require("./converters"), exports);
//# sourceMappingURL=sharedERCProcessor.js.map